import { Box, Link, Text } from "@chakra-ui/react";
import React from "react";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { MdOutlineMailOutline } from "react-icons/md";
import { MdLogoDev } from "react-icons/md";

const Footer = () => {
  return (
    <Box
      bg="rgba(30,41,59,0.7)"
      //   bg="linear-gradient(315deg,#fff 0%,#d7e1ec 74%)"
      w="full"
      h="full"
      p="1rem"
      pr="2rem"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexDir={{ base: "column", md: "row" }}
      gap="1rem"
    >
      <Box
        display="flex"
        alignItems="center"
        gap="0.5rem"
        color="#fff"
        fontSize="1.5rem"
      >
        <MdOutlineMailOutline />
        <Text color="#fff">mallijay747gmail.com</Text>
      </Box>
      <Box display="flex" alignItems="center" gap={6}>
        {[
          {
            id: 1,
            link: "https://github.com/JayMalli",
            icon: <BsGithub fontSize="1.5rem" />,
          },
          {
            id: 2,
            link: "https://www.linkedin.com/in/jaymalli/",
            icon: <BsLinkedin fontSize="1.5rem" />,
          },
          {
            id: 3,
            link: "https://dev.to/jaymalli_programmer",
            icon: <MdLogoDev fontSize="2rem" />,
          },
        ].map((item) => {
          return (
            <Box
              key={item.id}
              display="flex"
              alignItems="center"
              justifyContent="center"
              h="40px"
              w="40px"
              borderRadius="10px"
              bg="#fff"
            >
              <Link
                href={item.link}
                isExternal
                _hover={{ textDecoration: "none" }}
              >
                {item.icon}
              </Link>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Footer;
